module.exports = __webpack_public_path__ + "img/part1-dIcon3.a029f786.png";